import type { Capability } from '@clawharbor/manifest';
import { html } from '../html.js';
import type { VNode } from '../html.js';

/**
 * What actually shipped.
 *
 * The tool DESCRIPTION is the highest-leverage field in the whole manifest —
 * tool-selection accuracy is dominated by it — so it is shown in full rather
 * than truncated to a tidy line. This list is the thing the human is really
 * reviewing before they publish; a card that hides the text an agent will read
 * would make the review theatre.
 */

function argsOf(cap: Capability): string {
  const schema = cap.inputSchema as {
    properties?: Record<string, unknown>;
    required?: string[];
  };
  const names = Object.keys(schema.properties ?? {});
  if (!names.length) return 'no arguments';
  const required = new Set(schema.required ?? []);
  return names.map((n) => (required.has(n) ? `${n}*` : n)).join('  ');
}

export function CapabilityCard(cap: Capability): VNode {
  return html`
    <li class="cap">
      <div class="cap__top">
        <span class="cap__name">${cap.name}</span>
        <span class=${cap.kind === 'read' ? 'cap__kind' : 'cap__kind cap__kind--stage'}>
          ${cap.kind}
        </span>
        <span class="cap__title">${cap.title}</span>
      </div>
      <p class="cap__desc">${cap.description}</p>
      <p class="cap__args">${argsOf(cap)} → view:${cap.view}</p>
      ${cap.verified
        ? html`<p class="cap__verified">
            Verified against the live origin · ${cap.verified.samples} sample${
              cap.verified.samples === 1 ? '' : 's'
            } · ${Math.round(cap.verified.passRate * 100)}% pass
          </p>`
        : null}
    </li>
  `;
}

export function CapabilityList(props: { capabilities: Capability[] }): VNode {
  return html`<ul class="caps">${props.capabilities.map((c) => CapabilityCard(c))}</ul>`;
}
